import { useState } from "react";
import "./FAQ.css"; // custom styles

function FAQ() {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            heading: "What CFO services do you offer in the USA?",
            description:
                "At CFO Bridge USA, we provide comprehensive CFO services in the USA for startups, SMEs, and growing businesses. Our offerings include virtual CFO services, outsourced CFO services, fractional CFO, part-time CFO, and CFO consulting all designed to support your financial growth, compliance, and strategy."
        },
        {
            heading:
                "What are virtual CFO services and how can they benefit my business in the USA?",
            description:
                "Virtual CFO services in the USA offer remote financial leadership and strategic guidance without the cost of a full-time CFO. Businesses across the U.S. can benefit from expert financial planning, cash flow management, and budgeting through our virtual CFO in USA model boosting profitability while keeping overheads low."
        },
        {
            heading: "How do outsourced CFO services in the USA work?",
            description:
                "Outsourced CFO services in the USA give you access to seasoned financial professionals who manage your financial operations, reporting, and planning. At CFO Bridge, we act as your strategic finance partner, allowing you to focus on core business activities while we handle the numbers.",
        },
        {
            heading: "What's the difference between fractional and part-time CFO services?",
            description: "Fractional CFO services in the USA provide a senior finance expert on a part-time or need-based engagement, offering strategic insights and planning. A part-time CFO in USA often works on a fixed schedule, assisting with ongoing financial operations. Both are cost-effective alternatives to hiring a full-time CFO.     "
        },
        {
            heading: "Why should I consider CFO consulting for my business in the USA?",
            description: "CFO consulting in the USA provides specialized financial advice tailored to your business stage and goals. Whether you're planning expansion, fundraising, or operational improvements, our consultants help you strengthen your financial systems and align your strategy for long-term success."
        },
        {
            heading: "Can I hire a part-time CFO in the USA?",
            description: "Absolutely. CFO Bridge offers part-time CFO services in the USA to help small and mid-sized businesses gain access to expert financial leadership. This flexible model ensures you get the strategic input you need without the long-term commitment or cost of a full-time executive."
        },
        {
            heading: "How do virtual CFO services differ from traditional CFO hiring?",
            description: "Virtual CFO services offer remote, flexible financial leadership, making them ideal for U.S. based companies looking for agility and cost savings. Unlike a traditional CFO hire, a virtual CFO in the USA works on-demand, providing high-level financial strategy, forecasting, and reporting as needed."
        }

    ];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="faq-section">
            <div className="faq-container">
                <h2 className="faq-title">FAQ's</h2>
                <div className="faq-accordion">
                    {faqs.map((faq, i) => (
                        <div
                            className={`faq-item ${activeIndex === i ? "active" : ""}`}
                            key={i}
                        >
                            <button
                                className="faq-question"
                                onClick={() => toggleAccordion(i)}
                            >
                                {faq.heading}
                                <span
                                    className={`faq-icon ${activeIndex === i ? "rotate" : ""}`}
                                >
                                    ▼
                                </span>
                            </button>
                            <div
                                className="faq-answer"
                                style={{
                                    maxHeight: activeIndex === i ? "500px" : "0px",
                                }}
                            >
                                <p>{faq.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default FAQ;
